<template lang="pug">
.inventory-product(
  :class="{ 'inventory-product--clickable': clickable }"
  @click="onClick"
)
  .inventory-product__header
    .inventory-product__reference.uppercase(:title="reference") {{ reference }}
    .inventory-product__size.uppercase {{ size }}
  .inventory-product__image-wrap
    component.inventory-product__image-link(
      :is="clickable ? 'div' : 'a'"
      :href="clickable ? undefined : imageUrl"
      :target="clickable ? undefined : '_blank'"
    )
      img.inventory-product__image(:src="imageUrl" :alt="reference")
    span.inventory-product__quantity {{ quantity }}
</template>

<script>
import mForm from '@/mixins/form'

export default {
  name: 'InventoryProduct',

  mixins: [mForm],

  props: {
    reference: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    brand: {
      type: String,
      required: true
    },
    folder: {
      type: String,
      required: true
    },
    subfolder: {
      type: String,
      required: true
    },
    image: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick () {
      if (this.clickable) this.$emit('click')
    }
  },

  computed: {
    imageUrl () {
      if (!this.image) return this.noImagePathProduct
      const avifImage = this.image.replace('.jpg', '.avif')
      return `${this.imagePath}/${this.brand}/${this.folder}/${this.subfolder}/${avifImage}`
    }
  }
}
</script>

<style lang="stylus" scoped>
.inventory-product
  display flex
  flex-direction column
  align-items flex-start
  gap .35em
  width 100%

.inventory-product--clickable
  cursor pointer

.inventory-product__header
  display flex
  align-items flex-end
  justify-content space-between
  gap .5em
  width 100%

.inventory-product__reference
  font-size 1.05em
  font-weight 700
  line-height 1.15
  text-align left
  word-break break-all
  flex 1
  min-width 0

.inventory-product__size
  font-size 1.05em
  font-weight 700
  line-height 1
  flex-shrink 0

.inventory-product__image-wrap
  position relative
  width 100%

.inventory-product__image
  width 100%
  height auto
  display block

.inventory-product__quantity
  position absolute
  right .5em
  bottom .5em
  font-size 1.05em
  font-weight 700
  line-height 1
  padding .2em .35em
  background rgba(255, 255, 255, .88)
</style>



// WEBPACK FOOTER //
// src/components/pages/inventory/edit/Product.vue